import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LogoHeaderComponent } from './components/logo-header/logo-header.component';
import { MainButtonComponent } from './components/main-button/main-button.component';
import { RouterModule } from "@angular/router";
import { SelectBoxComponent } from './components/select-box/select-box.component';
import { TextBoxComponent } from './components/text-box/text-box.component';
import { SimpleInputComponent } from './components/simple-input/simple-input.component';
import { ReactiveFormsModule } from "@angular/forms";
import { PlanSelectionBoxComponent } from './components/plan-selection-box/plan-selection-box.component';
import { SimpleAccordionComponent } from './components/simple-accordion/simple-accordion.component';
import { TextHighlightPipe } from './pipes/text-highlight.pipe';
import { CodeVerificationInputComponent } from './components/code-verification-input/code-verification-input.component';
import { ToggleButtonComponent } from './components/toggle-button/toggle-button.component';
import { ToastPopUpComponent } from './components/toast-pop-up/toast-pop-up.component';
import { PlanReviewBoxComponent } from './components/plan-review-box/plan-review-box.component';
import { HttpClientModule } from '@angular/common/http';
import { NgxMaskModule } from 'ngx-mask';
import { LoaderScreenComponent } from './components/loader-screen/loader-screen.component';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PhoneLinkPipe } from './pipes/phone-link.pipe';

@NgModule({
  declarations: [
    LogoHeaderComponent,
    MainButtonComponent,
    SelectBoxComponent,
    TextBoxComponent,
    SimpleInputComponent,
    PlanSelectionBoxComponent,
    SimpleAccordionComponent,
    TextHighlightPipe,
    CodeVerificationInputComponent,
    ToggleButtonComponent,
    ToastPopUpComponent,
    PlanReviewBoxComponent,
    LoaderScreenComponent,
    PhoneLinkPipe,
  ],
  exports: [
    LogoHeaderComponent,
    MainButtonComponent,
    SelectBoxComponent,
    TextBoxComponent,
    SimpleInputComponent,
    PlanSelectionBoxComponent,
    SimpleAccordionComponent,
    TextHighlightPipe,
    CodeVerificationInputComponent,
    ToggleButtonComponent,
    ToastPopUpComponent,
    PlanReviewBoxComponent,
    LoaderScreenComponent,
    PhoneLinkPipe,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    HttpClientModule,
    NgxMaskModule,
    MatProgressSpinnerModule
  ]
})
export class SharedModule {
}
